<template>
  <div>
    <form-title>课程信息</form-title>
    <info-panel>
      <el-form
        ref="creatStep1Form"
        :model="creatStep1Form"
        :rules="creatStep1Rules"
        label-width="80px"
      >
        <el-row
          :gutter="col/2"
          type="flex"
          align="middle"
        >
          <el-col :span="col/2">
            <el-form-item
              label="课程名称"
              prop="courseName"
            >
              <el-input v-model="creatStep1Form.courseName" />
            </el-form-item>
          </el-col>
          <el-col :span="col/2">
            <el-form-item
              label="课程类型"
              prop="courseCategoryId"
            >
              <el-select
                v-model="creatStep1Form.courseCategoryId"
                placeholder="请选择课程分类"
                filterable
                clearable
              >
                <el-option
                  v-for="item in courseCategoryList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="col">
            <el-form-item
              label="课程简介"
              prop="courseSimpleIntro"
            >
              <el-input
                v-model="creatStep1Form.courseSimpleIntro"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="col*2"
            class="btns"
          >
            <el-button @click="cancel">
              取消
            </el-button>
            <el-button
              type="primary"
              @click="next"
            >
              下一步
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
  </div>
</template>
<script>
import formTitle from '@/components/common/formTitle.vue';
import infoPanel from '@/components/common/infoPanel.vue';
import axClient from '@/services';

export default {
  name: 'CreatStep1',
  components: { formTitle, infoPanel },
  props: {
    form: {
      default: () => ({
        courseName: '',
        courseCategoryName: '',
        courseSimpleIntro: '',
      }),
      type: Object,
    },
  },
  data() {
    return {
      isEdit: !!this.$route.params.courseClassId,
      creatStep1Form: {
        courseName: null,
        courseCategoryId: '',
        courseSimpleIntro: '',
      },
      col: 12,
      courseCategoryList: [],
      creatStep1Rules: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
        courseCategoryId: [
          { required: true, message: '请选择课程类型', trigger: 'blur' },
        ],
        courseSimpleIntro: [
          { required: true, message: '请输入课程简介', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    form() {
      this.creatStep1Form = { ...this.form };
    },
  },
  mounted() {
    this.selectList();
    this.creatStep1Form = { ...this.form };
  },
  methods: {
    // 取消
    cancel() {
      this.$router.go(-1);
    },
    // 下一步
    next() {
      this.$refs.creatStep1Form.validate((valid) => {
        if (valid) {
          const courseCategoryName = this.courseCategoryList.filter((v) => v.id === this.creatStep1Form.courseCategoryId).map((v) => v.value).join();
          this.$emit('next', { courseCategoryName, ...this.creatStep1Form });
        }
      });
    },
    // 下拉列表
    async selectList() {
      this.courseCategoryList = await axClient.course.listCategoryName();
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  margin-top: 15px;
}
</style>